


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrdersFilterDialog extends Vue {
  @Prop({default: ''}) title: any;
  @Prop({default: 'Open'}) buttonText: any;
  @Prop({default: 'Apply'}) applyText: any;

  dialog: boolean = false;
}
